<template>
  <main class="post-single" id="post-single">
    <div class="post-loading" v-if="loading">
      <Icon name="loader" />
    </div>
    <transition name="post-single">
      <div class="post-single-wrapper" v-if="post && !loading">
        <NavBar
          :title="post.title"
          :buttonName="`YIS ${post.type === 'luxuryindustrytalks' ? capitalize('luxury talks') : capitalize(post.type)}`"
          :backTo="`/${post.type}${(tag && tag !== null) ? '/tag/' + tag : ''}`"
        />
        <header class="post-single-header">
          <ImageBackground :src="post.featured_image.large ? post.featured_image.large : ''" />
          <div class="post-single-title">
            <div class="post-single-title-info" v-if="post.type == 'news' || post.type === 'luxuryindustrytalks' || post.type === 'jobs'">{{post.date}} by {{post.author}}</div>
            <h1>{{post.title}}</h1>
            <Share :url="`https://www.yachtinteriorsociety.com/${post.type}/${post.slug}/`" :title="post.title" :image="post.featured_image.large"/>
          </div>
          <BottomScroll to="#post-single-container" />
        </header>
        <div class="post-single-container" id="post-single-container">
          <div class="content-wrapper">
            <div class="content" :style="`width: ${size.width}; margin-left: ${size.margin};`">
              <AdFeatured
                  v-if="post.banners && post.banners.banner_featured"
                  :content="post.banners.banner_featured"
                />
              <div
                class="content-element"
                v-for="(element, index) in post.content"
                :key="element.acf_fc_layout + index"
              >
                <component :is="element.acf_fc_layout" v-bind="{content: element, imageClick: imageClick}" v-bind:url="`https://www.yachtinteriorsociety.com/${post.type}/${post.slug}/`" />
                <Ad
                  v-if="index === 1 && post.banners && post.banners.banner_top"
                  :content="post.banners.banner_top"
                />
              </div>
            </div>
          </div>
          <aside class="aside-wrapper">
            <div class="aside">
              <Ad
                v-if="post.banners && post.banners.banner_top"
                :content="post.banners.banner_top"
              />
              <PostsShortcuts
                v-if="post.related"                
                :title="`${capitalize(post.type == 'about' ? 'related' : post.type == 'luxuryindustrytalks' ? 'related talks' : post.type == 'jobs' ? 'similar jobs' : 'related ' + post.type)}`"
                :items="post.related"
              />
              <div class="aide-newsletter fade-in-anim-all fade-in-anim-all-hide">
                <div class="aside-title">Sign up to Newsletter</div>
                <Newsletter :side="true"/>
              </div>
              <PostsShortcuts
                v-if="post.product_recommendations"
                title="Recommendations"
                :items="post.product_recommendations"
              />
              <PostsShortcuts
                v-if="post.job_recommendations"
                title="Jobs"
                :items="post.job_recommendations"
              />
              <Ad
                v-if="post.banners && post.banners.banner_bottom"
                :content="post.banners.banner_bottom"
              />
            </div>
          </aside>
          <div class="post-bottom">
            <!-- POST DETAILS FOR JOB -->
            <!-- <div class="post-contact-jobs" v-if="post.type == 'jobs' && post.details">
              <div class="element" v-for="(detail, index) in post.details" :key="detail.type + index">
                <div class="title" v-if="detail.description">{{detail.description}}</div>
                <div class="text" v-if="detail.content && detail.type == 'text'">
                  <p>{{detail.content}}</p>
                </div>
                <div class="text" v-if="detail.content && detail.type == 'url'">
                  <a target="_blank" :href="detail.content" >{{detail.content}}</a>
                </div>
                <div class="text" v-if="detail.content && detail.type == 'phone'">
                  <a :href="`tel:${detail.content}`">{{detail.content}}</a>
                </div>
                <div class="text" v-if="detail.content && detail.type == 'email'">
                  <a :href="`mailto:${detail.content}`">{{detail.content}}</a>
                </div>
              </div>
              <div class="line"></div>
            </div>  -->
            <!-- POST CONTACT -->
            <div class="post-contact" v-if="post.type !== 'post' && post.contact && post.type !== 'luxuryindustrytalks'">
              <div class="element" v-if="post.type !== 'about'">
                <div class="title" v-if="post.type !== 'jobs'">Website:</div>
                <div class="title" v-if="post.type == 'jobs'">Job link:</div>
                <div class="text">
                  <a target="_blank" :href="post.contact.website.url" v-if="post.contact.website.url">{{post.contact.website.name}}</a>
                  <p  v-if="!post.contact.website.url">Not available</p>
                </div>
              </div>
              <div class="element">
                <div class="title" v-if="post.type == 'about'">e-mail:</div>
                <div class="title" v-if="post.type !== 'about'">Contact:</div>
                <div class="text">
                  <a :href="`mailto:${post.contact.email}`" v-if="post.contact.email">{{post.contact.email}}</a>
                  <p  v-if="!post.contact.email">Not available</p>
                </div>
              </div>
              <div class="element" v-if="post.type !== 'about'">
                <div class="title">Phone number:</div>
                <div class="text">
                  <a :href="`tel:${post.contact.phone}`" v-if="post.contact.phone">{{post.contact.phone}}</a>
                  <p  v-if="!post.contact.phone">Not available</p>
                </div>
              </div>
              <div class="element" v-if="post.type !== 'about'">
                <div class="title" v-if="post.type !== 'jobs'">Address:</div>
                <div class="title" v-if="post.type == 'jobs'">Job location:</div>
                <div class="text"  v-if="post.contact.address" v-html="post.contact.address"></div>
                <div class="text" v-if="!post.contact.address"><p>Not available</p></div>
                <!-- <div class="text">{{post.contact.address}}</div> -->
              </div>
              <div class="line"></div>
            </div>
            <div class="post-pagination">
              <div class="post-pagination-content">
                <div class="post-pagination-item prev">
                  <router-link
                    :to="`/${post.type}/${post.previous_post.slug}/`"
                    class="post-pagination-item-content"
                    v-if="post.previous_post"
                  >                                       
                    <strong v-if="post.type === 'about'">Previous</strong>
                    <strong v-else-if="post.type === 'partners'">Previous partner</strong>  
                    <strong v-else-if="post.type === 'events'">Previous event</strong>    
                    <strong v-else-if="post.type === 'jobs'">Previous job</strong>                
                    <strong v-else>Previous article</strong> 
                    <div class="title">
                      <span>{{post.previous_post.title}}</span>
                    </div>
                  </router-link>
                </div>
                <div class="post-pagination-item">
                  <router-link
                    :to="`/${post.type}/${post.next_post.slug}/`"
                    class="post-pagination-item-content"
                    v-if="post.next_post"
                  >
                    <strong v-if="post.type === 'about'">Next</strong>
                    <strong v-else-if="post.type === 'partners'">Next partner</strong>  
                    <strong v-else-if="post.type === 'events'">Next event</strong>
                    <strong v-else-if="post.type === 'jobs'">Next job</strong>                     
                    <strong v-else>Next article</strong> 
                    <div class="title">
                      <span>{{post.next_post.title}}</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- <div class="post-tags" v-if="post.tags && post.type !== 'about'">
              <div class="read-more">Read More About</div>
              <ul class="post-tags-list">
                <li class="tag" v-for="tag in post.tags" :key="tag.id">
                  <router-link class="button" :to="`/${post.type}/tag/${tag.slug}/`">
                    <span>{{tag.name}}</span>
                  </router-link>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>
    </transition>
    <Modal />
  </main>
</template>

<script>
import { get } from "@/api";
import { mapActions, mapGetters } from "vuex";
import NavBar from "@/components/NavBar";
import ImageBackground from "@/components/ImageBackground";
import Ad from "@/components/Ad";
import AdFeatured from "@/components/AdFeatured";
import Share from "@/modules/Share";
import PostsShortcuts from "@/modules/PostsShortcuts";
import Icon from "@/components/Icon";
import BottomScroll from "@/components/BottomScroll";
import Newsletter from "@/modules/Newsletter";
import Modal from "@/components/Modal";

import heading_text_image from "@/modules/postcontents/heading_text_image";
import image_text_black from "@/modules/postcontents/image_text_black";
import three_images_with_text from "@/modules/postcontents/three_images_with_text";
import text_with_grey_bar from "@/modules/postcontents/text_with_grey_bar";
import image_with_grey_bar from "@/modules/postcontents/image_with_grey_bar";
import oembed_video from "@/modules/postcontents/oembed_video";
import embed_instagram from "@/modules/postcontents/embed_instagram";
import text_with_instagram from "@/modules/postcontents/text_with_instagram";
import register_form from "@/modules/postcontents/register_form";
import date_and_time from "@/modules/postcontents/date_and_time";

export default {
  name: "Post",
  components: {
    NavBar,
    ImageBackground,
    Ad,
    AdFeatured,
    Share,
    PostsShortcuts,
    Icon,
    Newsletter,
    BottomScroll,
    Modal,
    // MODULES
    heading_text_image,
    image_text_black,
    three_images_with_text,
    text_with_grey_bar,
    image_with_grey_bar,
    oembed_video,
    embed_instagram,
    text_with_instagram,
    register_form,
    date_and_time
  },
  data: () => ({
    post: null,
    loading: true,
    size: {
      width: null,
      margin: null
    },
    newsletter_timeout: null,
    tag: null
  }),
  computed: mapGetters(["isMobile", "showMenuOpen", "postsTag"]),
  created() {
    //set newsletter on mobile
    if (sessionStorage.getItem("newsletter") != "true") {
      this.newsletter_timeout = setTimeout(() => {
        if (this.isMobile) {
          if (!this.showMenuOpen) {
            this.toggleMenu();
            this.setNewsletterOpen(true);
            sessionStorage.setItem("newsletter", true);
          }
        }
      }, 20000);
      this.tag = this.postsTag;
      this.setPostsTag(null);
    }
    get(
      `posts/${
        this.$route.params.name === "news" ? "post" : this.$route.params.name
      }/${this.$route.params.slug}`,
      (err, post) => {
        // console.log('----------get---------------');
        // console.log(err);
        // console.log(post);
        if (post) {
          this.setData(err, post);
        } else {
          this.$router.push("/404");
        }
      }
    );
  },
  beforeRouteUpdate(to, from, next) {    
    if (from.params.name === to.name || `${from.params.name}-tag` === to.name) {
      next();
    } else {
      this.setPosts(null);
      next();
    }
  },
  beforeRouteLeave(to, from, next) {    
    if (from.params.name === to.name || `${from.params.name}-tag` === to.name) {
      next();
    } else {
      this.setPosts(null);
      next();
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResizePost);
    clearTimeout(this.newsletter_timeout);
  },
  methods: {
    ...mapActions([
      "setLogoOnlyOnTop",
      "setNavBar",
      "setLogoOnTop",
      "toggleMenu",
      "setNewsletterOpen",
      "setPosts",
      "setPostsTag",
      "setShowModal",
      "setModalImage"
    ]),
    setData(err, post) {
      // console.log('----------setData---------------');
      // console.log(err);
      // console.log(post);
      if (post) {
        // document.title = post.title + " - Yacht Interior Society";
        document.title = post.titleYoast;
        this.post = post;
        this.loading = false;
        this.handleResizePost();
        window.addEventListener("resize", this.handleResizePost);
      }
    },
    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    handleResizePost() {
      setTimeout(() => {
        if (window.innerWidth > 1280) {
          const ofset = document.getElementById("post-single-container")
            .offsetLeft;
          this.size = {
            margin: `-${ofset}px`
          };
        } else {
          this.size = {
            margin: `0px`
          };
        }
      }, 0);
    },
    imageClick(image, caption) {
      this.setShowModal(true)
      this.setModalImage({
        image: image,
        caption: caption ? caption : null
      })
    }
  }
};
</script>

<style lang="scss">
.post-single {
  min-height: 100vh;
  & ~ .follow {
    z-index: 999;
  }
  .post-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
  }
  .post-single-wrapper {
    .post-single-header {
      position: relative;
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      .image-background {
        overflow: hidden;
        .image {
          transition: transform 4s;
        }
      }
      .post-single-title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        .post-single-title-info {
          @include josefinsans-light;
          font-size: 20px;
          margin-bottom: 35px;
          color: rgba(255, 255, 255, 0.5);
          transition: all 1s;
        }
        h1 {
          @include oswald;
          text-transform: uppercase;
          letter-spacing: 0.2em;
          margin-bottom: 85px;
          transition: all 1s;
          transition-delay: 0.2s;
        }
        .share {
          transition: all 1s;
          transition-delay: 0.4s;
        }
      }
    }
    .post-single-container {
      display: flex;
      flex-wrap: wrap;
      /* max-width: $wrapper-size;
      width: 80%; */
      width: 95%;
      margin: 0 auto;
      .content-wrapper {
        position: relative;
        flex: 1;
        color: $black;
        &:before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          width: 100vw;
          height: 100%;
          background: $white;
          z-index: 0;
        }
        .content {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          &:before,
          &:after {
            content: "";
            position: absolute;
            top: -100vh;
            left: 10%;
            width: 1px;
            height: calc(100% + 100vh);
            background: #9e9e9e;
            opacity: 0.3;
          }
          &:after {
            left: calc(35% + 100px);
          }
          .ad {
            display: none;
          }
          .content-element {
            max-width: 1194px;
            width: 100%;
          }
          p {
            @include opensans-light;
            margin-bottom: 1.6em;
            strong {
              text-decoration: none;
              background: none;
              color: inherit;
            }
            strong {
              @include opensans-light;
              font-weight: bold;
            }
          }
          h1,
          h2,
          h3,
          h4,
          h5,
          h6 {
            margin-bottom: 1.4em;
          }
          em {
            font-style: italic;
          }
          ul {
            list-style: square;
          }
          ol {
            list-style: decimal;
          }
          ul,
          ol {
            margin-bottom: 1.4em;
            list-style-position: inside;
            &:last-child {
              margin-bottom: 0;
            }
            li {
              @include opensans-light;
              font-size: 16px;
              line-height: 1.8em;
            }
          }
          iframe {
            max-width: 100%;
          }
          blockquote {
            margin-bottom: 1.6em;
            padding: 0;
            p {
              padding: 0;
            }
          }
        }
      }
      .aside-wrapper {
        position: relative;
        padding: 70px 0 70px 50px;
        width: 400px;
        .aside {
          max-width: 400px;
          .ad {
            justify-content: flex-start;
          }
          .aide-newsletter {
            .aside-title {
              @include josefinsans-light;
              font-size: 24px;
              line-height: 1em;
              text-transform: uppercase;
            }
          }
        }
      }
      .post-bottom {
        width: 100%;
        .post-pagination {
          margin: 80px 400px 80px 0;
          .post-pagination-content {
            display: flex;
            justify-content: space-between;
            .post-pagination-item {
              width: 50%;
              text-align: right;
              padding-left: 15px;
              &:hover {
                strong {
                  color: $white;
                }
                .title {
                  span {
                    background-size: 100% 2px;
                    color: $pink;
                  }
                }
              }
              &.prev {
                padding-left: 0px;
                padding-right: 15px;
                text-align: left;
              }
              strong {
                font-size: 16px;
                line-height: 30px;
                color: $pink;
                text-transform: uppercase;
                transition: all 0.3s;
              }
              .title {
                @include opensans-light;
                font-size: 16px;
                line-height: 30px;
                span {
                  background-image: linear-gradient(currentColor, currentColor);
                  background-position: 0% 100%;
                  background-repeat: no-repeat;
                  background-size: 0% 2px;
                  transition: all 0.3s;
                }
              }
            }
          }
        }
        .post-contact {
          display: flex;
          flex-wrap: wrap;
          margin: 80px 400px 80px 0;
          .element {
            width: 33.3333%;
            font-size: 14px;
            line-height: 30px;
            .title {
              text-transform: uppercase;
              margin-bottom: 20px;
              margin-right: 20px;
            }
            .text {
              @include opensans-light;
              color: $light-grey;
              margin-bottom: 20px;
              flex: 1;
              a {
                @include josefinsans-regular;
                text-transform: uppercase;
                color: $pink;
              }
              p{
                font-size: 14px;
              }
            }
            &:nth-child(3) {
              text-align: right;
              .title {
                margin-right: 0px;
              }
            }
            &:nth-child(4) {
              width: 100%;
              display: flex;
              .text {
                text-align: right;  
                font-size: 14px;  
                line-height: normal; 
                margin-top: 2px;
                p{
                  font-size: 14px;  
                }
              }
            }
          }          
        }
        .post-contact-jobs {
          display: flex;
          flex-wrap: wrap;
          margin: 80px 400px 80px 0;
          // background-color: red;
          .element {
            width: 30.33333333%;
            font-size: 14px;
            line-height: 30px;
            .title {
              text-transform: uppercase;
              margin-bottom: 20px;
              margin-right: 20px;
            }
            .text {
              @include opensans-light;
              color: $light-grey;
              margin-bottom: 20px;
              flex: 1;
              a {
                @include josefinsans-regular;
                text-transform: uppercase;
                color: $pink;
                line-height: 10px;
                overflow-wrap: break-word;
              }
              p{
                font-size: 14px;
              }
            }
          }          
        }
        .post-tags {
          margin: 80px 0;
          .read-more {
            text-transform: uppercase;
            margin-bottom: 60px;
            font-size: 26px;
            @include josefinsans-light;
            line-height: 1.4em;
          }
          .post-tags-list {
            display: flex;
            flex-wrap: wrap;
            .tag {
              margin-top: 20px;
              margin-right: 20px;
            }
          }
        }
        .line{
          height: 1px;
          width: 100%;
          border-top: 1px solid rgba(255, 255, 255, 0.15);
        }
      }
    }
  }
}
@media (max-width: $desktop) {
  .post-single {
    .post-single-wrapper {
      .post-single-container {
        width: 100%;
        flex-direction: column;
        .content-wrapper {
          order: 1;
          width: 100%;
          justify-content: center;
          &:before {
            right: 50%;
            transform: translateX(50%);
          }
          .content {
            width: 100%;
            .content-element {
              max-width: 100%;
            }
            .ad {
              display: flex;
              margin: 25px 0;
            }
          }
        }
        .aside-wrapper {
          width: 80%;
          margin: 0 auto;
          padding: 50px 0;
          order: 3;
          .aside {
            max-width: 100%;
            .aide-newsletter {
              display: none;
            }
            .ad {
              justify-content: center;
              &:last-child {
                display: none;
              }
            }
          }
        }
        .post-bottom {
          margin: 0 auto;
          width: 80%;
          order: 2;
          .post-pagination,
          .post-contact,
          .post-tags,
          .post-contact-jobs {
            margin: 40px 0px;
          }
          .post-tags {
            .read-more {
              margin-bottom: 30px;
            }
          }
        }
      }
    }
  }
}
@media (max-width: $tablet) {
  .post-single {
    .post-single-wrapper {
      .post-single-container {
        .content-wrapper {
          .content {
            &:before {
              left: calc(10% + 80px);
            }
            &:after {
              left: calc(35%);
            }
            ul,
            ol {
              li {
                font-size: 14px;
              }
            }
          }
        }
        .aside-wrapper {
          width: 90%;
        }
        .post-bottom {
          width: 90%;
          .post-tags {
            .read-more {
               font-size: 20px;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 815px) {
  .post-single {
    .post-single-wrapper {
      .post-single-container {
        .aside-wrapper {
          .aside {
            .ad{
              .ad-title{
                margin-left: 0;
              }
            }
          }
        }       
      }
    }
  }
}
@media (max-width: $mobile) {
  .post-single {
    .post-single-wrapper {
      .post-single-container {
        .content-wrapper {
          .content {
            &:before {
              left: 5%;
            }
            &:after {
              left: 50vw;
            }
          }
        }
        .post-bottom {
          .post-pagination {
            .post-pagination-content {
              flex-direction: column;
              .post-pagination-item {
                width: 100%;
                &.prev {
                  margin-bottom: 30px;
                }
              }
            }
          }
          .post-contact {            
            .element {
              width: 100%;
              display: flex;
              font-size: 12px;
              line-height: 20px;              
              &:nth-child(3) {
                text-align: left;
                .title {
                  margin-right: 20px;                  
                }
              }
              &:nth-child(4) {            
                .text {                                                         
                  text-align: left;  
                  font-size: 12px;  
                  line-height: 12px; 
                  margin-top: 0px;
                }
              }
            }
          }
          .post-contact-jobs{            
            .element {
              width: 100%;
              display: flex;
              font-size: 12px;
              line-height: 20px;              
            .text {
              min-width: 0;
            }
            }             
          }
        }
      }
    }
  }
}
.post-single-enter-active,
.post-single-leave-active {
  .post-single-header {
    .image-background {
      .image {
        transform: scale(1.2);
      }
    }
    .post-single-title {
      .post-single-title-info {
        transform: translateY(100px);
        opacity: 0;
      }
      h1 {
        transform: translateY(100px);
        opacity: 0;
      }
      .share {
        transform: translateY(100px);
        opacity: 0;
      }
    }
  }
}
</style>